// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ee58b156","732":"e1eafd9b","977":"5c41410e"}[chunkId] + ".chunk.js";
};